import { render, staticRenderFns } from "./NewPolicyDialogue.vue?vue&type=template&id=1cd7c50e&scoped=true"
import script from "./NewPolicyDialogue.vue?vue&type=script&lang=ts"
export * from "./NewPolicyDialogue.vue?vue&type=script&lang=ts"
import style0 from "./NewPolicyDialogue.vue?vue&type=style&index=0&id=1cd7c50e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd7c50e",
  null
  
)

export default component.exports